// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--iFOa2","close":"dd31006766--close--cuwuV","left":"dd31006766--left--MomBO","title":"dd31006766--title--wihdt"};